import React from 'react';
import { CheckSquareOutlined } from '@ant-design/icons';

import cn from './styles.module.scss';

type SurveySeasonBadgeProps = {
  label: string;
};

export function SurveySeasonBadge({ label }: SurveySeasonBadgeProps) {
  return (
    <span className={cn.badge} data-testid="surveySeasonBadge">
      <CheckSquareOutlined />
      {label}
    </span>
  );
}
